/** Pie plano del kit: quién mantiene el sistema y de quién es. */
export function PiePlano() {
  return (
    <footer className="dcc-footer dcc-footer--plano">
      <p className="dcc-footer__linea">
        <span>Área de Desarrollo de Software</span>
        <span className="dcc-footer__sep" aria-hidden="true">·</span>
        <span><strong>Departamento de Ciencias de la Computación</strong></span>
        <span className="dcc-footer__sep" aria-hidden="true">·</span>
        <span><strong>Universidad de Chile</strong></span>
        <span className="dcc-footer__sep" aria-hidden="true">·</span>
        <span>© {new Date().getFullYear()}</span>
      </p>
    </footer>
  )
}
